import { moduleApi } from "@amtana/module";
import type { EraseStep } from "@amtana/module";

import type {
  NotifyInput,
  PushSubscriptionSummary,
  SubscribeInput,
  UnsubscribeInput,
  UnsubscribeOutput,
  VapidPublicKey,
} from "./push.schemas.ts";

// The promise push makes to everyone else. Owns subscriptions (one per
// device, D087), the VAPID key pair and the send wire; never knows what
// kind of notification it is sending for, so this module names nothing of
// notification's own domain (its peers only pass it plain fields).

export type ForUser = { readonly userId: string };

export interface PushApi extends EraseStep {
  /** Subscribes this device, or replaces its subscription if it already had one (D087): one
   * row per person per `deviceId`. Refuses a loopback endpoint outside development (D092). */
  subscribe(input: ForUser & SubscribeInput): Promise<PushSubscriptionSummary>;
  /** Removes this device's subscription; harmless to call for a device that never had one. */
  unsubscribe(input: ForUser & UnsubscribeInput): Promise<UnsubscribeOutput>;
  /** The server's VAPID public key, for `PushManager.subscribe`'s `applicationServerKey`. */
  vapidPublicKey(): Promise<VapidPublicKey>;
  /** Sends one payload to every device this person has subscribed; drops any subscription the
   * push service says is gone (404/410). Peer-only: the caller already decided this is
   * wanted (notification's own snooze and quiet-hours check happens before this is called),
   * and never throws. */
  notify(input: NotifyInput): Promise<void>;
}

export const PushApi = moduleApi<PushApi>()("push");
